/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExtractAll = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 20h16v-2h2v4H2v-4h2zm0-6h16v-2h2v4H2v-4h2zm13.707-6.707-1.414 1.414L13 5.414V12h-2V5.414L7.707 8.707 6.293 7.293 12 1.586z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgExtractAll as ExtractAll };
